import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface SliceModel {
    error: boolean,
    loading: boolean,
    success: boolean,
    workHubSubscriptionData: any,
    workhubConfigData: any,
    workhubUpdateResp: any,
    monthlyRentalData: any,
    licenceCount: number
}

interface MonthlyRentalPayload {
    licenseType: string;
    licenceCount: number;
}

const workhubStore = createSlice({
    name: "workhub-store",
    initialState: {
        error: false,
        loading: false,
        success: false,
        workHubSubscriptionData: null,
        workhubConfigData: null,
        workhubUpdateResp: null,
        monthlyRentalData: null,
        licenceCount: 0,
    } as SliceModel,
    reducers: {
        workhubSubscriptionDataFetch: (state: SliceModel) => {
            return {
                ...state,
                error: false,
                loading: true,
                success: false
            }
        },
        workhubSubscriptionDataFetchSuccess: (state: SliceModel, action: PayloadAction<any>) => {
            return {
                ...state,
                error: false,
                loading: false,
                success: true,
                workHubSubscriptionData: action.payload
            }
        },
        workhubSubscriptionDataFetchFail: (state: SliceModel) => {
            return {
                ...state,
                error: true,
                loading: false,
                success: false
            }
        },
        workhubSubscriptionDataSave: (state: SliceModel, action: PayloadAction<any>) => {
            return {
                ...state,
                workhubConfigData: action.payload
            }
        },
        workhubSubscriptionDataUpdate: (state: SliceModel) => {
            return {
                ...state,
                error: false,
                loading: true,
                success: false
            }
        },
        workhubSubscriptionDataUpdateSuccess: (state: SliceModel, action: PayloadAction<any>) => {
            return {
                ...state,
                error: false,
                loading: false,
                success: true,
                workhubUpdateResp: action.payload
            }
        },
        workhubSubscriptionDataUpdateFail: (state: SliceModel) => {
            return {
                ...state,
                error: true,
                loading: false,
                success: false
            }
        },
        monthlyRentalFetch: (state: SliceModel, action: PayloadAction<MonthlyRentalPayload>) => {
            return {
                ...state,
                error: false,
                loading: true,
                success: false,
                licenseType: action.payload.licenseType,
                licenceCount: action.payload.licenceCount
            }
        },
        monthlyRentalFetchSuccess: (state: SliceModel, action: PayloadAction<any>) => {
            return {
                ...state,
                error: false,
                loading: false,
                success: true,
                monthlyRentalData: action.payload
            }
        },
        monthlyRentalFetchFail: (state: SliceModel) => {
            return {
                ...state,
                error: true,
                loading: false,
                success: false
            }
        },
        workHubSubscriptionDetailsFetch: (state: SliceModel) => {
            return {
                ...state,
                error: false,
                loading: true,
                success: false
            }
        },
        workHubSubscriptionDetailsFetchSuccess: (state: SliceModel, action: PayloadAction<any>) => {
            return {
                ...state,
                error: false,
                loading: false,
                success: true,
                subscriptionData: action.payload
            }
        },
        workHubSubscriptionDetailsFetchFail: (state: SliceModel) => {
            return {
                ...state,
                error: true,
                loading: false,
                success: false
            }
        },
    },
});

export default workhubStore;
